
import { getEquipmentOptions } from "@/common/filter"
import { SvgImageEditor } from "@/components/SvgImageEditor"
import { createProjectEquipments, OrganizationEquipmentService } from "@/services/project/equipment/equipment.service"
import { SimiulatorEquipment } from "@/types/equipment"
import { useRequest } from "ahooks"
import { Form, Input, InputNumber, Modal, ModalProps, Select } from "antd"
import { useMemo, useState } from "react"
import ReactDOM from "react-dom"

interface CreateEquipmentProps extends ModalProps {
  projectId?: number
  onSuccess?: () => void
  equipment?: SimiulatorEquipment
  orgId?: number
}

export function CreateEquipment(props: CreateEquipmentProps) {
  const { projectId, onSuccess, onCancel, orgId } = props
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm()

  const { loading, run } = useRequest(
    (values) => {
      if (orgId) {
        return OrganizationEquipmentService.createEquipment(orgId, values)
      }
      return createProjectEquipments(values)
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess?.()
      }
    }
  )

  const handleCancel = (e?) => {
    setVisible(false)
    onCancel?.(e)
  }


  return <Modal
    {...props}
    width={600}
    visible={visible}
    onCancel={handleCancel}
    onOk={() => form.submit()}
  >
    <div>Add Equipment</div>
    <Form
      form={form}
      onFinish={(values) => {
        console.log(values)
        run(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter nozzle name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Width' name='width' rules={[{ required: true, message: 'Please enter image width' }]}>
        <InputNumber type='number' style={{width: '100%'}} />
      </Form.Item>

      <Form.Item label='Height' name='height' rules={[{ required: true, message: 'Please enter image height' }]}>
        <InputNumber type='number' style={{width: '100%'}} />
      </Form.Item>

      <Form.Item label='Type' name='type' rules={[{ required: true, message: 'Please selected a nozzle type' }]}>
        <Select options={getEquipmentOptions()} />
      </Form.Item>

      <Form.Item label='SVG Image' name='image'>
        <SvgImageEditor />
      </Form.Item>

    </Form>
  </Modal>
}

CreateEquipment.show = (props: CreateEquipmentProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <CreateEquipment
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
    />,
    div
  )
}